<script setup lang="ts">
import type { DebugInfo } from '../composables/useScanner';
import type { VoteState } from '../../engine/vote/votingEngine';
import type { ScanMode } from '../../engine/types';

defineProps<{ debug: DebugInfo; mode: ScanMode; vote: VoteState | null }>();
</script>

<template>
  <div class="debug-overlay">
    <div>
      ep=<b>{{ debug.ep }}</b> thr={{ debug.threads }} iso={{ debug.crossOriginIsolated ? 1 : 0 }}
      mode={{ mode }}
    </div>
    <div>
      fps det={{ debug.detectorFps.toFixed(1) }} e2e={{ debug.e2eFps.toFixed(1) }}
      frame={{ debug.frameW }}×{{ debug.frameH }}
    </div>
    <div v-if="debug.timings">
      ms det={{ debug.timings.detect.toFixed(0) }} rect={{ debug.timings.rectify.toFixed(0) }}
      ocr={{ debug.timings.ocr.toFixed(0) }} tot={{ debug.timings.total.toFixed(0) }}
    </div>
    <div v-if="vote">
      vote: {{ vote.status }} «{{ vote.text }}» n={{ vote.groupLen }}/{{ vote.bufferLen }}
      pat={{ vote.patternId }}
      <span v-if="vote.region">reg={{ vote.region.name }}</span>
    </div>
    <div v-for="r in debug.recentRaw" :key="r.raw + r.conf" class="tiny">
      {{ r.accepted ? '✓' : '✗' }} {{ r.raw }} {{ (r.conf * 100).toFixed(0) }}%
    </div>
    <table v-if="debug.voteTable.length" class="vote-table">
      <tr v-for="row in debug.voteTable" :key="row.pos">
        <td>{{ row.pos }}</td>
        <td v-for="v in row.votes.slice(0, 3)" :key="v.ch">
          {{ v.ch }}:{{ (v.share * 100).toFixed(0) }}
        </td>
      </tr>
    </table>
  </div>
</template>
